import { useTranslation } from 'react-i18next'

/**
 * A simple loading indicator with spinning icon and text.
 *
 * Displays a centered loading spinner with translated "Loading ..." text.
 * Takes full width and height of its container.
 *
 * @example
 * ```tsx
 * // In a container that needs loading state
 * {isLoading ? <Loading /> : <Content />}
 *
 * // In a full-screen loading state
 * <div className="min-h-screen">
 *   <Loading />
 * </div>
 * ```
 */
export function Loading() {
  const { t } = useTranslation('common')
  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="flex justify-center items-center space-x-1 text-sm text-foreground">
        <svg
          fill="none"
          className="w-6 h-6 animate-spin"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            d="M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </svg>
        <div>{t('states.loading')}</div>
      </div>
    </div>
  )
}
